import { CircleValidateAndAssignSponsorshipRequest } from '@calm/evexia-web-sdk';
import { useSponsorshipMutation } from '@rhg/hooks/use-sponsorship-mutation';
import { getRhgAppAppendHeader } from '@rhg/utils/browser';
import { getSSOSessionStorageData } from '@rhg/utils/sso';

export default function useJoinSponsorship() {
    const { isInitialSSO, isLinkedSsoUser } = getSSOSessionStorageData();

    const { mutate, mutateAsync, ...otherProps } =
        useSponsorshipMutation<CircleValidateAndAssignSponsorshipRequest>(
            (api, { partnerId, circle, request, activationToken }) =>
                api.v1ValidateAndAssignSponsorship(
                    {
                        partnerId,
                        circleAuthorizationToken: circle.authorizationJWT,
                        recipientId: circle.recipient.id,
                        circleValidateAndAssignSponsorshipRequest: request,
                        xPartnerMemberActivationToken: activationToken,
                    },
                    {
                        headers: {
                            ...getRhgAppAppendHeader({
                                registration_flow:
                                    isInitialSSO && !isLinkedSsoUser
                                        ? 'sso'
                                        : 'direct',
                            }),
                        },
                    }
                )
        );
    return {
        joinSponsorship: mutate,
        joinSponsorshipAsync: mutateAsync,
        ...otherProps,
    };
}
